import { PhoneInput as AntdPhoneInput } from "@empglabs/backoffice-ui-kit"

const PhoneInput = props => {
  return <AntdPhoneInput {...props} />
}

export default PhoneInput
